import enLocale from 'element-ui/lib/locale/lang/en'

const en = {
  message: {
    // 基础
    'config': 'Config',
    'history': 'History',
    'creator':'Creator',
    'info': 'Info',
    'beginTime': 'Begin Time',
    'endTime': 'End Time',

    'loginTitle': 'Welcome to ',
    'titleEnd': 'Verifone',
    'login': 'LOGIN',
    'passwordLogin': 'Password',
    'usernameLogin': 'Username',
    'verification': 'Verification Code',
    'rememberPassword': 'Remember the password',
    'forgetPassword': 'Forget password?',
    'English': 'English',
    'Chinese': 'Chinese',
    'menuSubtitle': 'Application Veristore',
    'changePassword': 'Change Password',
    'usernameChange': 'User Name',
    'currentPassword': 'Current Password',
    'newPassword': 'New Password',
    'content': '7-15 digits numbers and upper and lower case letters',
    'confirmPassword': 'Password Confirmation',
    'submit': 'Submit',
    'back': 'back',
    'quit': 'Quit',
    'add': 'Add',
    'edit': 'Edit',
    'delete': 'Delete',
    'cancel': 'Cancel',
    'upload': 'Upload',
    'import': 'Import',
    'warning': 'Warning',
    'callTitle': 'Please dial:',
    'warn': 'Warning',
    'modifyPassword': 'Modify Password',
    'logoutTip': 'Logout',
    'selectTip':'Operator Display',
    //dashboard
    'dashboard': 'Dashboard',
    'totalTerminal': 'TOTAL TERMINAL',
    'activeTerminal': 'ACTIVE TERMINAL',
    'totalApp': 'TOTAL APPS',
    'totalAppDownload': 'TOTAL APP DOWNLOADS',
    'downloadUper': 'DOWNLOADING TASKS',
    'todayAppDownload': 'TODAY APP DOWNLOADS',
    'downloadStatistics': 'DOWNLOAD STATISTICS',
    'notDownload': 'Not Download',
    'downloaded': 'Downloaded',
    'toBeInstalled': 'To Be Installed',
    'installed': 'Installed',
    'newApp': 'NEW APPS',
    'monthlyDownload': 'MONTHLY DOWNLOADS',
    'topApp': 'TOP APPS',
    'downloads': 'DOWNLOADS',
    'yes': 'Yes',
    'no': 'No',
    'ok': 'OK',
    'commonTip': 'Click the search key',
    //App
    'app': 'APP',
    'appSearch': "Enter app's name to search",
    'version': 'Version',
    'developer': 'Developer',
    'company': 'Company Name',
    'date': 'Date',
    'LastDate': 'Last Contact Date',
    'size': 'Size',
    'operation': 'Operation',
    'appBaic': 'APP Basic Information',
    'appParameterEdit': 'APP Parameter Edit',
    'templateEdit': 'Terminal Parameter Template Edit',
    'apkFile': 'APK File',
    'icon': 'ICON',
    'packageName': 'Package Name',
    'appName': 'APP Name',
    'intoduction': 'Introduction',
    'uninstall': 'Uninstall',
    'enable': 'Enable',
    'disable': 'Disable',
    'resourceFile': 'Resource File',
    'UploadResource':'Upload Resource File',
    'appParameter': 'APP Parameters',
    'terminalParameterTemplate': 'Terminal Parameter Template',
    'charTip50': '1-40characters',
    'charTip200':　'1-200characters',
    'uploadTipAPK': 'Upload APK file',
    'uploadTipXML': 'Upload XML file',
    'appCreateAsk': 'APP Parameter changed, create download task?',
    'nextContact': 'Next contact',
    'databaseName': 'Database Field Name',
    'name': 'Name',
    'value': 'Value',
    'defaultValue':'DefaultValue',
    'description': 'Description',
    'fixedLength': 'Fixed Length',
    'maxLength': 'Max Length',
    'bulkEditMark': 'Bulk Edit',
    'versionExample': 'such as 1.1.0',
    'deleteApp': 'Are you sure you want to delete the application "',
    'deleteAppTop': 'Are you sure you want to delete the application "',
    'deleteAppFoot':'"? APP parameters, terminal parameters  will be deleted together.',
    'enterContent': 'Please enter the content',
    'true': 'true',
    'false': 'false',
     'enter': 'enter',
    'resourceNameSameCheck': 'The name of new resource is the same as the old one . When you upload new resource ,please you delete the old one.',
    'appResourceFileMax':'The number of App resource files has reached critical so that  the resource files can be added again.',
    'resourceFileTaskCreateAsk': 'APP resource file changed, create download task?',
    'appUploadTime':"APP Upload Time",
    'resourceUrl':'Resource Url',
    //download
    'download': 'Download',
    'createTaskMenu': 'Create APP Download Task',
    'createTaskDeleteMenu':'Create APP Uninstall Task',
    'downloadTasks': 'Download Tasks',
    'createTask': 'Create Task',
    'downloadDelete': 'Create Uninstall Task ',
    'createDeleteTask':'Create Task',
    'DeleteTaskName':'Uninstall Task Name',
    'deleteTime':'Uninstall Time',
    'ImmediatelyDelete':'Delete Immediately',
    'DeleteTime':'Date&Time',
    'DeleteWarning':'Uninstall Notification',
    'SilentUninstall':'Silent Uninstall',
    'askOperator':'Ask for operator confirmation',
    'appChoose': 'Apps choose',
    'downloadName': 'Download Task Name',
    'downloadTime': 'Download Time',
    'dateTime': 'Date&Time',
    'installTime1':'Date&Time',
    'installTime': 'Install Time',
    'installImmediately': 'Immediately after download',
    'installNotify': 'Install notification',
    'silentInstall': 'Silent Installation',
    'askCashier': "Ask for cashier's confirmation",
    'pushRange': 'Release range',
    'allTerminal': 'All terminals',
    'grayscale': 'Grayscale',
    'downloadCreate': 'Are you sure you want to create app download "',
    'createBack': 'If you are leaving the page, you will lose the current content ? ',
    'downloadTask': 'Download Task',
    'type': 'Type',
    'createDate': 'Create Date',
    'total': 'Total',
    'totals': 'total',
    'items': 'items',
    'downSuccess': 'Download Success',
    'downFail': 'Download Failed',
    'notStart': 'Not Started',
    'installSuccess': 'Install Success',
    'installFail': 'Install Failed',
    'delSuccess': 'Delete Success',
    'delFail': 'Delete Failed',
    'status': 'Status',
    'inprogress': 'In Progress',
    'done': 'Done',
    'cancelled': 'Cancelled',
    'appList': 'APP List',
    'downloadCancel': 'Are you sure you want to cancel task "',
    'pleaseChoose': 'Please choose',
    'time': 'Time',
    'appLists': 'APP Lists',
    'appResourceFile':'APP ResourceFile Download',
    'downloading':'Downloading',

    // 删除任务
    'forceUninstall': 'Force Uninstall',

    //merchant
    'merchant': 'Merchant',
    'merchantManage': 'Merchant Management',
    'merchantInformation': 'Merchant Information',
    'groupManage': 'Group Management',
    'merchantName': 'Merchant Name',
    'contactName': 'Contact Name',
    'country': 'Country/Region',
    'state': 'States',
    'district': 'District',
    'address': 'Address',
    'merchantTip': 'Enter merchant name to search',
    'phoneNo': 'Mobile Phone Number',
    'email': 'E-mail',
    'companyName': 'Company Name',
    'companies':'Company',
    'city': 'City',
    'postcode': 'Postcode',
    'Email': 'Email',
    'telephoneNo': 'Telephone Number',
    'groupName': 'Group Name',
    'terminals': 'Terminals',
    'groupTip': 'Enter group name to search',
    'addTerminals': 'Add Terminals',
    'searchKeyword': 'Search Keyword',
    'selectArea': 'Select The Area',
    'sn': 'SN',
    'province': 'Province',
    'area': 'Area',
    'totalOf': 'Total',
    'equipmentInquire': 'Equipment Inquiries',
    'deleteGroup': 'Are you sure you want to delete group "',
    'deleteMerchant': 'Are you sure you want to delete merchant "',
    'deleteUser': 'Are you sure you want to delete user "',
    'functionManage':'Function Management',
    'function':'Function',
    'functionType':'Function Type',
    'functionAdd':'Function Config Add',
    'functionEdit':'Function Config Edit',
    'functionConfigurationManagement':'function Configuration Management',
    'groupNameCheck':'Please Select A Group Name',
    'functionConfigCheck':'Please Select Function',
    'deleteGroupFunction':'Are you sure you want to delete group:"',
    'landlineNumber':'Landline number',
    'areaCode':'Area code',
    'areaCodeCheck':'Please enter the correct area code',
    'areaTypeCheck':'Incorrect area code format',
    //terminal
    'export':'Export',
    'paramExport':'Parameter',
    'terminal': 'Terminal',//modify
    'map': 'Map',
    'model': 'Model',
    'terminalParam': 'Terminal Parameter',
    'appParam': 'App Parameter',
    'appDownload': 'App Download',
    'appDelete':'App Delete',
    'copy': 'Copy',
    'copyTerminal': 'Copy Terminal',
    'copyNote': 'Note: This function copies the APP information, terminal parameter information, merchant, group and other information of the selected device, input the SN for the new terminal.',
    'group': 'Group',
    'terminalLists': 'Terminal Parameter Lists',
    'valueEdit': 'Value(Edit)',
    'item': 'Items',
    'terminalCreateTask': 'Parameter changed, create download task?',
    'deleteTerminal': 'Are you sure you want to delete terminal SN:"',
    'addTerminal': 'Add New Terminal',
    'terminalEdit': 'Terminal Information',
    'totalTerminals': 'Total Terminals',
    'chooseAppPage':'Page for APP ',
    'plsAddingAPP': 'Please add APP you need',
    'tickAPP': 'Please Tick APP',
    'terminalParameterEmpty': 'Terminal parameters is null ',
    'terminalCountLabelTail': 'Terminals',
    'terminalChoosed':'Terminals Choosed',
    'activeReportTime':'Last online time',
    'alertStatus': 'Alert Status',
    'pn':'PN',
    'createTaskTipsStart':'All terminals that installed',
    'createTaskTipsEnd':'will be included in the download task.',
    'createDelTaskTipsEnd':'will be included in the uninstall task.',

    // 终端编辑 - 位置服务
    'movingWarn': "Relocation Alert",
    'movingTrack': 'Location Tracking',
    'openMovingTrackMsg': 'Whether to open the location to report the service, after the service will be opened the number of flow',
    'movingTrackSwitch': 'Location Tracking',
    'locationService': 'Location Service',
    'locationInfo': 'Location Info',
    'locationServiceConfig':'Config',
    'relocationAlert': 'Alert',
    'movingDistance': 'Limitation',
    'locationUploadInterval': 'Location Upload Interval',
    'locationUploadCreateTaskMsg': 'Terminal location config changed, will create download task.The configuration will take effect after the download is complete.',
    'locationUploadIntervalError': 'Location upload interval not less than 5 minute',
    'lastReportTime':'Last Report Time',
    'locationUploadAlert1': 'The client should be uploaded to the service and more than 1.7.0.',
    'locationUploadAlert2': 'The service is not available',
    'movingEffectiveTime': 'Start Time',
    'trajectoryMessage':'No data during this time',
    'selectedLocation': 'Selected Location',
    'selectedLocationTip1': 'Current Red Point on the map',
    'selectedLocationTip2': 'Blue point on the map',
    'selectedLocationTip3': 'Please select location on the map',
    'selectStartingPoint': 'Select Starting Point',
    'optCurrentLocation': 'Current Location',
    'optSelectLocation': 'Selected Location',
    'optSelectNewLocation': 'Select New Location',


    //diagnostic
    'diagnostic': 'Remote Diagnosis',
    'rom': 'ROM Version',
    'k21': 'Secure Driver Version',
    'currentInstall': 'Installed App',
    'diagnosticData': 'Diagnostic data',
    'paramName': 'Parameter name',
    'imei': 'IMEI',
    'meid': 'MEID',
    'memoryTotal': 'Total RAM',
    'memoryAvailable': 'Available RAM',
    'flashTotal': 'Total Flash',
    'flashAvailable':'Available Flash ',
    'mobileDataFlow':'Total mobile data flow',
    'turnOnOffTimes':'Power Cycle Times',
    'turnOnTime':' Uptime',
    'turnOnTimeSummary':'Total Uptime',
    'printerLength':'Length of printing',
    'cardTimes':'Magnetic Card Swipe times',
    'icCardTimes':'Contact Card insert times',
    'untouchCardTimes':'Contactless Card Tap Times',
    'frontCameraOpenTimes':' Front Camera Opening Times',
    'backCameraOpenTimes':'Rear Camera Opening Times',
    'batteryTemperature':'Battery Temperature',
    'battery':' Battery Percentage',
    'batteryChargeTimes':'Charging Cycles',
    'androidVersion':'Android Version',
    'spSystemVersion':'Security Chip System Version',
    'spProtocolVersion':'Security Chip Protocol Version',
    'mainBoardBatteryVoltage':'MainBoard Battery Voltage',
    'wifiMacAddress':'Wifi Mac Address',
    'wifiIpAddress':'Wifi Ip Address',
    'lanMacAddress':'Lan MAC Address',
    'lanIpAddress':'Lan IP Address',
    'mobileIpAddress':'Mobile Ip Address',
    'language':'Language',
    'mobileNetworkType':'Mobile Network Type',
    'mobileNetworkSignal':'Mobile Network Signal',
    'mobileMonthlyDataFlow':'Mobile Monthly Data Flow',
    'k21Version':'Secure Driver Version',
    'romVersion':'ROM Version',
    'mobileNumber': 'Mobile Number',
    'networkOperatorName': 'Network Operator Name',
    'location':'Location',

    //alert
    'alert': 'Alert',
    'openAlert': 'Open Alerts',
    'alertHistory': 'Alert History',
    'level': 'Level',
    'high': 'High',
    'middle': 'Middle',
    'close': 'Close',
    'closeAll': 'Close All',
    'closedTip': 'Closed Success!',
    'moveAlertCloseInfo': 'Do you need to turn off the switch alarm configuration for this terminal?',

    //user
    'users': 'Users',//modify
    'userTip': 'Enter account name to search',
    'accountName': 'Account Name',
    'subordinate': 'Users Information',
    'basicInfo': 'Basic Information',
    'firstName': 'First Name',
    'lastName': 'Last Name',
    'reconfirm': 'Reconfirm',
    'selectAll': 'Select All',
    'merchantManagement': 'Merchant Management',
    'appManagement': 'APP Management',
    'terminalManagement': 'Terminal Management',
    'downloadManagement': 'App Download Management',
    'diagnosticManagement': 'Diagnostic Management',
    'alertManagement': 'Alert Management',
    'userManagement': 'User Management',
    'merchantQuery': 'Merchant Query',
    'appQuery': 'APP Query',
    'terminalQuery': 'Terminal Query',
    'downloadQuery': 'App Download Query',
    'alertQuery': 'Alert Query',
    'reportCreate':'Report Create',
    'permission':'Permission',
    'systemManage':'System Manage',
    //tip
    'loginSuccess': 'Login successfully!',
    'logout': 'Logout successfully!',
    'submitSuccess': 'Submit successfully!',
    'saveSuccess': 'Save successfully!',
    'deleteSuccess': 'Delete successfully!',
    'modifySuccess': 'Modify successfully!',
    'createSuccess': 'Create successfully!',
    'building':'Building...',
    'uploadSuccess': 'Upload successfully!',
    'cancelSuccess': 'Cancel successfully!',
    'closeSuccess': 'Close successfully!',
    'addSuccess': 'Add successfully!',
    'inputCheck': 'Spaces are not allowed!',
    'sameCheck': 'The new password is the same as the old one',
    'validCheck':'Valid Password',
    'fileCheck':'The size of file exceeded',
    'veryCheck': 'The verification code is empty!',
    'userNameCheck': 'The username cannot be empty!',
    'passWordCheck':'The password cannot be empty!',
    'userNameLength':'The length of username exceeded!',
    'passWordLength':'The length of password exceeded!',
    'passwordCheck': 'Passwords do not match. Please try again!',
    'resellerNameCheck':'No reseller selected',
   /* 'passwordChecked': 'Please enter correct password',*/
    'emailCheck': 'Please enter the correct email format',
    'phoneCheck':'Please enter the correct telephone format',
    'imgCheck': 'Please upload the correct image format',
    'xmlCheck': 'Please upload an XML file',
    'dateCheck': 'Please enter download date or time',
    'installDateCheck': 'Please enter install date or time',
     'validDownloadTimes':'Dowanload end time less than download start time',
    'invalidTime': 'Invalid Time',
    'chooseApp': 'Please choose at least one APP',
    'chooseOneApp': 'Please choose an APP',
    'forceDelete': 'Sure to delete this APP? The download task containing this APP will also be deleted',
    'forceEdit': 'Are you sure you want to update the APK package?Undone download tasks containing this app will also be deleted.',
    'resourceType': 'Type',
    'others':'Others',
    'resourceVersion': 'Version',
    'file':'File',
    'enterKeyword': 'Enter keyword to search',
    'enterSN': 'Enter SN to search',
    'enterApp': "Enter App's name to search",
    'enterAccount': 'Enter Account Name to search',
    'parameter': 'Parameter',
    'resetPassword': 'Reset Password',
    'reset': 'Reset',
    'resetSuccess': 'Reset successfully!',
    'accountEmail': 'Account Name(E-mail)',
    //2018-11-13
    'groupTerminal': 'Group Terminal List',
    'terminalList': 'Terminal List',
    'triggerTransfer': 'Trigger the transfer',
    'tamperCode': 'Tamper Code',
    'failureCode': 'Failure Code',
    'initialCoordinate':'Initial Coordinate',
    'currentCoordinate': 'Current Coordinate',
    'moveDistance': 'Moving Distance',
    'freeMemory': 'Free memory',
    'freeStorage': 'Free Storage Space',
    'deviceId': 'Device ID',
    //2019-07-02
    'sure': 'Sure',

    //2020-07-24
    'join': 'Join',
    'pleaseTick':'Please check first',
    'noTickTerminal': 'Terminal is not checked, whether to select all?',
    'taskId': 'TaskId',

    //终端预警状态
    'normal': 'normal',
    'terminalNoConnect': 'Terminal no Connect',
    'terminalLost': 'Terminal lost',
    'appTaskFailure': 'App task failure',
    'terminalMove': 'Terminal moved',
    'tamper': 'Tamper',
    'lowMemory': 'Low memory',
    'printerAgeing': 'Printer ageing',
    'batteryAgeing': 'Battery ageing',
    'otherError': 'Other error',

    //report
    'report':'Report',
    'createReport':'Create Report',
    'reportDetail':'Report Detail',
    'reportDownload':'Report Download',
    'TerminalList':'Terminal List',
    'TerminalParameter':'Terminal Parameter',
    'TerminalReportDetail':'Terminal Report Detail',
    'TerminalParameterDetail':'Terminal Parameter Detail',
    'lat':'Lat',
    'lng':'Lng',
    'createTime':'Create Time',
    'resellerName':'Reseller Name',
    'timeZone':'Time Zone',
    'reportName':'Report Name',
    'No':'No',
    'create':'Create',
    'reportId':'Report ID',
    'creating':'Creating',
    'completed':'Completed',
    'selectAPP':' Select APP',
    'downloadTaskStatusReport':'Download Task Status',
    'relocationWarningReport':'Relocation Alert',
    'searchDownloadTask':'Please Enter download taskName',
    'selectDownloadTask':'Download Task Search',
    'chooseDownloadTask':'Please Choose Download Task',
  },
  ...enLocale
}

export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js